import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { injectIntl } from 'react-intl-next';
import AkCode from '@atlaskit/code/inline';
import { codeBidiWarningMessages } from '@atlaskit/editor-common/messages';
export var isCodeMark = function isCodeMark(mark) {
  return mark && mark.type && mark.type.name === 'code';
};
export function CodeWithIntl(props) {
  var codeBidiWarningLabel = props.intl.formatMessage(codeBidiWarningMessages.label);
  return /*#__PURE__*/React.createElement(AkCode
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  , _extends({
    className: "code",
    codeBidiWarningLabel: codeBidiWarningLabel,
    codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props.dataAttributes), props.children);
}
export default injectIntl(CodeWithIntl);